export default __webpack_public_path__ + "static/instagram_icon-0579403b1e377d9cbdbe03092be63679.png";